import UserContainer from "../../../Components/DataTables/User/UserContainer";
import { useEffect } from "react";
import RoleGuard from "../../RoleGuard";
import { useAppSelector } from "../../../ReduxToolkit/Hooks";

const Users = () => {
  const { user } = useAppSelector((state) => state.auth);
  const currentUserRoles = user?.roles?.map((role) => role.slug) || [];
  useEffect(() => {
    document.title = "User Management";
  }, []);

  return (
    <>
      {/* RoleGuard ensures only allowed roles can view the page */}
      <RoleGuard userRoles={currentUserRoles} allowedRoles={["admin"]} />

      {/* Main content */}
      <UserContainer />
    </>
  );
};

export default Users;
